import { render, staticRenderFns } from "./messageTypeLeft.vue?vue&type=template&id=32c90cc1&scoped=true"
import script from "./messageTypeLeft.vue?vue&type=script&lang=js"
export * from "./messageTypeLeft.vue?vue&type=script&lang=js"
import style0 from "./messageTypeLeft.vue?vue&type=style&index=0&id=32c90cc1&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c90cc1",
  null
  
)

export default component.exports